export default "__VITE_ASSET__WiLwLCIY__"